<template>
  <header
    class="z-20 h-16 box-border bg-white fixed inset-x-0 top-0 w-full border-t-0 border-l-0 border-r-0 border-b border-gray-300 border-solid transition duration-200"
    :class="{
      'drop-shadow-lg': !pageIsOnTop,
      'drop-shadow-none': pageIsOnTop,
    }"
  >
    <div class="px-4 h-full flex items-center justify-between lg:justify-start">
      <MenuLogoBack />

      <div class="flex flex-1 justify-between h-full">
        <MenuPublicHorizontal
          v-if="
            useTemplateStoreInstance.getTemplate.value.header.showPublicMenu
          "
        />
      </div>

      <div
        v-if="useTemplateStoreInstance.getTemplate.value.header.showShare"
        class="h-full flex items-center justify-between"
      >
        <MenuShare />
      </div>

      <div
        v-if="useTemplateStoreInstance.getTemplate.value.header.showMenu"
        class="h-full flex items-center justify-between"
      >
        <RenderTemplateSidebar />
        <RenderTemplatePopover
          class="hidden lg:flex items-center justify-between h-full"
        />
      </div>
    </div>
  </header>
  <div class="h-16 z-0 relative" />
</template>

<script setup lang="ts">
import { useTemplateStore } from '~~/modules/template/stores/useTemplateStore'
const useTemplateStoreInstance = useTemplateStore()

const pageIsOnTop = ref(true)

onMounted(() => {
  if (import.meta.client) {
    window.addEventListener('scroll', handleScroll)
  }
})

onUnmounted(() => {
  if (import.meta.client) {
    window.removeEventListener('scroll', handleScroll)
  }
})

const handleScroll = () => {
  const currentScroll = window.pageYOffset
  if (currentScroll > 0) {
    pageIsOnTop.value = false
  } else {
    pageIsOnTop.value = true
  }
}
</script>
